export const isLocalOrPreviewEnv = (): boolean => {
  return ['local', 'preview'].includes(
    String(process.env.NEXT_PUBLIC_ENV || ''),
  );
};
